import BlogMysticApe from "@components/layout/blog/widget/mysticApe.js";
import * as React from 'react';
export default {
  BlogMysticApe,
  React
};